module.exports = __webpack_public_path__ + "static/media/Paladin_Protection.2503e88b.png";